import { storyblokEditable, renderRichText } from "@storyblok/react"
import { motion } from "framer-motion"
import { SvgCheckCircle } from "../../icons"

const item = {
  hidden: { opacity: 0, y: 14, filter: "blur(2px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.45, ease: "easeOut" },
  },
}

export default function GetItem({ blok }: any) {
  return (
    <motion.div
      {...storyblokEditable(blok)}
      variants={item}
      className="flex items-start gap-3"
    >
      <SvgCheckCircle className="text-[#4750F5] mt-1 w-5 h-5 flex-shrink-0" />
      <div>
        <div
          className="font-['BeausiteClassic'] text-base md:text-lg font-semibold text-gray-900 leading-snug"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.title || { content: [] }) || "",
          }}
        />
        <div
          className="font-['BeausiteClassic'] text-sm md:text-base text-gray-700 mt-1 leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.description || { content: [] }) || "",
          }}
        />
      </div>
    </motion.div>
  )
}
